<div class="wrapper">
  <div class="toolbar px-0">
    <h3 class="ml-0 pointer breadcrumb-back" [routerLink]="['/gamification/prosncons']"
      [queryParams]="{domain: domain}"><i class="fas fa-chevron-left"></i></h3>
    <h3 class="text-left">Pros for {{subparam_label|t}}</h3>
    <button class="btn btn-sm btn-warning text-white mr-0 px-2 btn-add" (click)="add('pro')">
      <i class="fa fa-plus"></i>
    </button>
  </div>
  <div class="tablescroll">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Pros</th>
          <th>Image</th>
          <th>Video</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of pros; let ind=index" style="border-radius: 4px;">
          <td style="border-right: 1px solid white; text-align: center; width: 55px">{{ind + 1}}</td>
          <td>{{item.description}}</td>
          <td>
            <img *ngIf="item.images.length" style="width: auto;height: 66px;margin-left: 30px;margin-right: 30px;"
              [src]="[item.pros_and_cons_id, item.images[0].image_id]|authImage:'pros_and_cons'|async">
          </td>
          <td>
            <!-- <img *ngIf="item.videos.length" style="width: auto;height: 66px;margin-left: 30px;margin-right: 30px;"
          [src]="[item.pros_and_cons_id, item.videos[0].video_id]|authImage:'pros_and_cons'|async"> -->
            <img *ngIf="item.videos.length" style="width: auto;height: 66px;margin-left: 30px;margin-right: 30px;"
              src="/assets/images/thumbnail.jpg">
          </td>
          <td>
            <img class="m-2 pointer mr-4" src="assets/images/ic_edit.svg" (click)="edit(item)">
            <img class="m-2 pointer mr-4" src="assets/images/ic_delete.svg" (click)="delete(item)">
          </td>
        </tr>
        <tr *ngIf="dataSub && !dataSub.closed">
          <td colspan="5">
            <div class="blink text-center py-4">Loading...</div>
          </td>
        </tr>
        <tr *ngIf="!(dataSub && !dataSub.closed) && !pros.length">
          <td colspan="5">
            <div class="text-center py-4">No Pros to display</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="toolbar px-0">
    <h3 class="text-left ml-40">Cons for {{subparam_label|t}}</h3>
    <button class="btn btn-sm btn-warning text-white mr-0 px-2 btn-add" (click)="add('con')">
      <i class="fa fa-plus"></i>
    </button>
  </div>
  <div class="tablescroll">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Cons</th>
          <th>Image</th>
          <th>Video</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of cons; let ind=index" style="border-radius: 4px;">
          <td style="text-align: center; width: 55px">{{ind + 1}}</td>
          <td>{{item.description}}</td>
          <td><img *ngIf="item.images.length" style="width: auto;height: 66px;margin-left: 30px;margin-right: 30px;"
              [src]="[item.pros_and_cons_id, item.images[0].image_id]|authImage:'pros_and_cons'|async">
          </td>
          <td>
            <!-- <img *ngIf="item.videos.length" style="width: auto;height: 66px;margin-left: 30px;margin-right: 30px;"
          [src]="[item.pros_and_cons_id, item.videos[0].video_id]|authImage:'pros_and_cons'|async"> -->
            <img *ngIf="item.videos.length" style="width: auto;height: 66px;margin-left: 30px;margin-right: 30px;"
              src="/assets/images/thumbnail.jpg">
          </td>
          <td>
            <img class="m-2 pointer mr-4" src="assets/images/ic_edit.svg" (click)="edit(item)">
            <img class="m-2 pointer" src="assets/images/ic_delete.svg" (click)="delete(item)">
          </td>
        </tr>
        <tr *ngIf="dataSub && !dataSub.closed">
          <td colspan="5">
            <div class="blink text-center py-4">Loading...</div>
          </td>
        </tr>
        <tr *ngIf="!(dataSub && !dataSub.closed) && !cons.length">
          <td colspan="5">
            <div class="text-center py-4">No Cons to display</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>